import { BreadCrumb } from "../components/BreadCrumb";
import transmissaoAoVivo from "../../assets/buttons/tv_zonta_aovivo.svg";
import { ContentContainer } from "../components/ContentContainer";
import { BigButtons } from "../components/BigButtons";
import videoConferencia from "../../assets/buttons/videoconferencia.svg";
import { useNavigate } from "react-router-dom";
import { MotionMain } from "../MotionMain";

export const AoVivoPage = () => {
  const navigate = useNavigate();

	return (
		<MotionMain key="/aovivo/index" className="flex flex-col h-full">
			<ContentContainer>
				<BreadCrumb
					H2Props={{
						className: "text-3xl pl-12 pb-6 md:pt-0 pt-6",
					}}
					steps={["Ao Vivo"]}
				/>
				<BigButtons
					buttons={[
						{
							label: "Video Conferência",
							backgroundUrl: videoConferencia,
							href: "https://app.zoom.us/wc/meetings?webp=1",
							target: "_blank",
						},
						{
							label: "Transmissão ao vivo",
							backgroundUrl: transmissaoAoVivo,
							onClick: () => {
								navigate("transmissaoaovivo");
							},
						},
					]}
				/>
			</ContentContainer>
		</MotionMain>
	);
};
